(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // Slick js
    $('.js-message-bar').slick({
      vertical: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      infinite: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elements-carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    var $slider = $('.js-elements-carousel');

    $slider.each(function (index, slider) {
      var $controls = $(slider).siblings('.elements-carousel__header').find('span.elements-carousel__heading-controls');
      $(slider).slick({
        infinite: false,
        slidesToShow: 2,
        arrows: true,
        appendArrows: $controls,
        responsive: [
          {
            breakpoint: 1120,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      // Slick js
      $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = (nextSlide / (slick.slideCount - 2)) * 100;

        if ($(window).width() < 1120) {
          calc = (nextSlide / (slick.slideCount - 1)) * 100;
        }

        $(this)
          .prev('.elements-carousel__hr')
          .find('.elements-carousel__hr-inner')
          .css('width', calc + '%');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    setTimeout(function () {
      var slider = $('.js-feature-carousel').slick({
        infinite: false,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        fade: true,
        prevArrow: $('.feature-carousel-prev'),
        nextArrow: $('.feature-carousel-next'),
      });
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-brands"] && !Shopify.designMode) return;
  try {
    
  var elem = $('.footer__group-inner'),
      animateTime = 500,
      trigger = $('.footer__group-button');
  trigger.click(function(){
    $(this).toggleClass('open');
    if(elem.height() === 0){
      autoHeightAnimate(elem, animateTime);
    } else {
      elem.stop().animate({ height: '0' }, animateTime);
    }
  });

  /* Function to animate height: auto */
  function autoHeightAnimate(element, time){
      var curHeight = element.height(), // Get Default Height
          autoHeight = element.css('height', 'auto').height(); // Get Auto Height
          element.height(curHeight); // Reset to Default Height
          element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Scroll to top
  var btn = $('#back-to-top');
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });
  btn.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      '500'
    );
  });

  // Toggle mobile nav
  $('.footer-block__heading-toggle').on('click', function () {
    $(this).closest('.footer-block--menu').toggleClass('open').find('.footer-block__details-content').slideToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.announcementBar) this.announcementBar.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcementBar) this.announcementBar.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcementBar) this.announcementBar.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.announcementBar) this.announcementBar.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBar) this.announcementBar.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) this.announcementBar.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const slider = document.querySelector('.js-hero-carousel');
  const playSpeed = slider.getAttribute('data-play-speed');

  body.classList.add('hero-exists');

  setTimeout(function () {
    $(slider).slick({
      infinite: true,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: playSpeed,
    });

    const updateTheme = (currentSlide) => {
      const isLight = currentSlide.classList.contains('hero-carousel__slide-container--light');
      const heroInner = currentSlide.closest('.hero-carousel__inner');

      heroInner.classList.toggle('current-slide-light-theme', isLight);
      heroInner.classList.toggle('current-slide-dark-theme', !isLight);

      body.classList.toggle('hero-exists--light-theme', isLight);
      body.classList.toggle('hero-exists--dark-theme', !isLight);
    };

    const currentSlide = slider.querySelector('.slick-current');
    updateTheme(currentSlide);

    slider.addEventListener('afterChange', function (event) {
      const currentSlide = slider.querySelector('.slick-current');
      updateTheme(currentSlide);
    });
  }, 1000);

  // Hover over header when hero exists
  const headerWrapper = document.querySelector('.header-wrapper');
  headerWrapper.addEventListener('mouseover', function () {
    body.classList.add('hover-on-header');
  });
  headerWrapper.addEventListener('mouseout', function () {
    body.classList.remove('hover-on-header');
  });

  const toggleSearchOpen = (isOpen) => body.classList.toggle('search-open', isOpen);

  document.querySelector('.header__icon--search').addEventListener('click', function() {
    const isOpen = this.closest('.header__search').querySelector('details').hasAttribute('open');
    toggleSearchOpen(!isOpen);
  });

  document.querySelector('.search-modal__close-button').addEventListener('click', function() {
    toggleSearchOpen(false);
  });

  document.querySelector('.search-modal .modal-overlay').addEventListener('click', function() {
    toggleSearchOpen(false);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  $('body').addClass('hero-exists');

  if ($('.hero').hasClass('hero--dark')) {
    $('body').addClass('hero-exists--light-theme');
  } else if ($('.hero').hasClass('hero--light')) {
    $('body').addClass('hero-exists--dark-theme');
  }

  $('.js-scroll-down').on('click', function (e) {
    var heroHeight = $('.hero').offset().top + $('.hero').outerHeight();
    e.preventDefault();
    $('html').animate(
      {
        scrollTop: heroHeight - $('.header').outerHeight(),
      },
      500
    );
  });

  // Hover over header when hero exists
  $('.header-wrapper').hover(function () { // mouse-in 
            $('body').addClass('hover-on-header'); 
        }, 
            function () { // mouse-out 
                $('body').removeClass('hover-on-header'); 
            } 
        ) 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(document).ready(function () {
    setTimeout(function () {
      $('.js-product-description-toggle').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-open');
        if ($(this).hasClass('is-open')) {
          $(this).text('Read less');
        } else {
          $(this).text('Read more');
        }
        $('.js-product-description-toggle').closest('.product__description-intro').next().slideToggle();
      });
    }, 1000);
  });

  const observer = new IntersectionObserver(
    (intersections) => {
      intersections.forEach(({ target, isIntersecting }) => {
        target.classList.toggle('animate', isIntersecting);
      });
    },
    {
      threshold: 0,
    }
  );

  document.querySelectorAll('.product-facts-fact__bar-overlay').forEach((span) => {
    observer.observe(span);
  });

  $(document).ready(function () {
    $sizeLabel = $('legend:contains("Size")');
    $fitValue = $('.product-fit-value-static');

    if ($sizeLabel.length != 0 && $('.product-size-fit').length) {
      console.log('both the size label and the size chart block exist');
      $sizeLabel.append('<a href="#" class="view-size-chart">View Size Guide</a>');

      // If we have a fit label as well
      if ($fitValue.length != 0) {
        console.log('test');
        $sizeLabel.append('<span class="product-fit-label">Fits</span><span class="product-fit-value">' + $fitValue.text() + '</span>');
      }
    }

    $('.view-size-chart').on('click', function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.product-size-fit').offset().top
      }, 500);
    });
    $('.product-fit-value').on('click', function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.product-size-fit').offset().top
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.js-product-carousel');
    
    sliders.forEach(slider => {
      const controls = slider.closest('.product-carousel').querySelector('.product-carousel__heading-controls');
      
      $(slider).slick({
        infinite: false,
        cssEase: 'linear',
        slidesToShow: 3,
        arrows: true,
        appendArrows: controls,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
      
      $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        const calc = (nextSlide / (slick.slideCount - 3)) * 100;
        slider.closest('.product-carousel').querySelector('.product-carousel__hr-inner').style.width = calc + '%';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-material-gallery"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    var $slider = $('.js-product-material-gallery');

    $slider.each(function (index, slider) {
      var $controls = $(slider).closest('.product-material-gallery__inner').siblings('.product-material-gallery__header').find('span.product-material-gallery__header-controls');
      $(slider).slick({
        infinite: false,
        slidesToShow: 3,
        arrows: true,
        appendArrows: $controls,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      // Slick js
      $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = (nextSlide / (slick.slideCount - 2)) * 100;

        if ($(window).width() < 1120) {
          calc = (nextSlide / (slick.slideCount - 1)) * 100;
        }

        $(this)
          .prev('.team-carousel__hr')
          .find('.team-carousel__hr-inner')
          .css('width', calc + '%');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-size-fit"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.js-product-size-fit-button-technical').on('click', function () {
      if (!$(this).hasClass('active')) {
        $(this).addClass('active');
        $('.js-product-size-fit-button-model').removeClass('active');
        $('.product-size-fit__main-right-images').removeClass('model-visible').addClass('technical-visible');
      }
    });

    $('.js-product-size-fit-button-model').on('click', function () {
      if (!$(this).hasClass('active')) {
        $(this).addClass('active');
        $('.js-product-size-fit-button-technical').removeClass('active');
        $('.product-size-fit__main-right-images').removeClass('technical-visible').addClass('model-visible');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product-carousel"] && !Shopify.designMode) return;
  try {
    
  function waitForElement(id, callback) {
    var poops = setInterval(function () {
      if (document.getElementById(id)) {
        clearInterval(poops);
        callback();
      }
    }, 100);
  }

  $(document).ready(function () {
    waitForElement('js-related-product-carousel', function () {
      var $slider = $('.js-related-product-carousel');
      var $controls = $slider.siblings('h2.related-product-carousel__heading').find('span.related-product-carousel__heading-controls');

      $slider.slick({
        infinite: false,
        slidesToShow: 3,
        arrows: true,
        appendArrows: $controls,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var calc = (nextSlide / (slick.slideCount - 3)) * 100;

      $(this)
        .prev('.related-product-carousel__hr')
        .find('.related-product-carousel__hr-inner')
        .css('width', calc + '%');
    });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-sidebar-nav-content"] && !Shopify.designMode) return;
  try {
    
  $('.sidebar-nav-content__sidebar-nav a').click(function () {
    $link = $(this).attr('href');
    console.log($link);
    $('html, body').animate(
      {
        scrollTop: $($link).offset().top - 46,
      },
      2000
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.js-team-carousel');

  sliders.forEach(slider => {
    const controls = slider.closest('.team-carousel').querySelector('.team-carousel__header-controls');

    // Initialize Slick slider
    $(slider).slick({
      infinite: false,
      slidesToShow: 2,
      arrows: true,
      appendArrows: $(controls),
      responsive: [
        {
          breakpoint: 1120,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      let calc = (nextSlide / (slick.slideCount - 2)) * 100;
      if (window.innerWidth < 1120) {
        calc = (nextSlide / (slick.slideCount - 1)) * 100;
      }
      slider.closest('.team-carousel').querySelector('.team-carousel__hr-inner').style.width = calc + '%';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
